/**
 * Toast notifications – re-export sonner for success/error feedback.
 * Use from client components: toast.success("Saved"), toast.error("Failed").
 */
export { toast } from "sonner";
